const GetNameFromXml = (xml) => {
    try {
        let regex = /diagram_name=\\"(.*)/g
        let replace = 'diagram_name=\\"'
        xml = xml.match(regex)
        xml = xml[0].replace(replace, "")
        return xml.slice(0, xml.indexOf('\\"')) 
    }
    catch (e)
    {
        console.error(e)
        return "----"
    }
}

export default GetNameFromXml;